// Drawer UI
export const NEWS_OPEN_DRAWER  = 'NEWS_OPEN_DRAWER';
export const NEWS_CLOSE_DRAWER = 'NEWS_CLOSE_DRAWER';
export const NEWS_SET_FILTER   = 'NEWS_SET_FILTER';

// Unseen count (badge)
export const NEWS_UNSEEN_COUNT_REQUEST = 'NEWS_UNSEEN_COUNT_REQUEST';
export const NEWS_UNSEEN_COUNT_SUCCESS = 'NEWS_UNSEEN_COUNT_SUCCESS';
export const NEWS_UNSEEN_COUNT_ERROR   = 'NEWS_UNSEEN_COUNT_ERROR';

// List
export const NEWS_LIST_REQUEST = 'NEWS_LIST_REQUEST';
export const NEWS_LIST_SUCCESS = 'NEWS_LIST_SUCCESS';
export const NEWS_LIST_ERROR   = 'NEWS_LIST_ERROR';

// Mark seen
export const NEWS_MARK_SEEN_SUCCESS = 'NEWS_MARK_SEEN_SUCCESS';

// Interactions
export const NEWS_INTERACTION_REQUEST = 'NEWS_INTERACTION_REQUEST';
export const NEWS_INTERACTION_SUCCESS = 'NEWS_INTERACTION_SUCCESS';
export const NEWS_INTERACTION_ERROR   = 'NEWS_INTERACTION_ERROR';



// WEBPACK FOOTER //
// ./src/components/news/store/types.js